type LayerFormPropertySeed = {
  key: string;
  value: unknown;
};

const UNIVERSAL_LAYER_FORM_PROPERTY_DEFAULTS: LayerFormPropertySeed[] = [
  {
    key: 'selection',
    value: false,
  },
];

const CORNER_RADIUS_DEFAULT: LayerFormPropertySeed = {
  key: 'cornerRadius',
  value: 0,
};

const LAYER_TYPES_WITH_CORNER_RADIUS = new Set([
  'RECTANGLE',
  'STAR',
  'REGULAR_POLYGON',
  'ELLIPSE',
  'FRAME',
  'COMPONENT_SET',
  'COMPONENT',
  'INSTANCE',
  'VECTOR',
  'BOOLEAN_OPERATION',
]);

export const getLayerFormPropertyDefaults = ({
  layerType,
  layerOrder,
}: {
  layerType: string;
  layerOrder: number;
}): LayerFormPropertySeed[] => {
  const defaults = [
    ...UNIVERSAL_LAYER_FORM_PROPERTY_DEFAULTS,
    {
      key: 'layerOrder',
      value: layerOrder,
    },
  ];

  if (LAYER_TYPES_WITH_CORNER_RADIUS.has(layerType)) {
    defaults.push(CORNER_RADIUS_DEFAULT);
  }

  return defaults;
};
